<template>
    <section class="row-12">
        <div class="col-12">
            <h3>Powiadomienia</h3>
            <transition>
                <div class="no-notifications w-100 text-a-c m-y-5" v-if="notificationsList.length === 0">Historia
                    przeczytanych powiadomień jest pusta.
                </div>
                <div v-else>
                    <div class="card col-12 m-b-2" v-for="notifications in notificationsList">
                        <div class="card-body row-12">
                            <div class="col-2 col-sm-4 center-flex-a">
                                <small class="text-primary">{{notifications.date}}</small>
                            </div>
                            <div class="col-10 col-sm-8 m-l-3">
                                <h4 class="m-0 m-b-1">{{notifications.title}}</h4>
                                <p class="m-0" v-html="notifications.content"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </section>
</template>

<script>
    export default {
        data: () => {
            return (
                {
                    notificationsList: []
                }
            )
        },
        async mounted() {
            this.notificationsList = await Notification.getAllRead()
        }
    }
</script>

<style>
    .no-notifications {
        color: #c5c5c5;
    }
</style>
